<template>
  <div class="test">
  <RouterView />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useGlobalStore } from './stores/global-store'

const GlobalStore = useGlobalStore()

// Отслеживаем активность пользователя
const setupActivityListeners = () => {
  const events = ['mousemove', 'keydown', 'scroll', 'click']
  
  const resetTimer = () => {
    if (GlobalStore.isAdmin) {
      GlobalStore.resetLogoutTimer()
    }
  }

  events.forEach(event => {
    window.addEventListener(event, resetTimer)
  })

  return () => {
    events.forEach(event => {
      window.removeEventListener(event, resetTimer)
    })
  }
}

onMounted(() => {
  GlobalStore.checkAuth()
  const cleanup = setupActivityListeners()
  
  onUnmounted(() => {
    cleanup()
  })
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
